<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onHide()"
  [contentStyle]="{ overflow: 'visible' }"
  [style]="{ width: '480px', maxWidth: '95vw' }">

  <ng-template #header>
    <div class="d-flex align-items-center gap-3">
      <i class="pi pi-inbox" style="font-size: 1.5rem; color: var(--acx-primary)"></i>
      <div>
        <div class="fw-semibold">
          {{ 'AgentManagement::AssignQueue:Title' | abpLocalization }} &mdash; {{ agent?.fullName }}
        </div>
        <div class="text-muted small">{{ agent?.email }}</div>
      </div>
    </div>
  </ng-template>

  <div *ngIf="loading" class="text-center py-4">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <ng-container *ngIf="!loading">
    <!-- Info box -->
    <div class="alert alert-info border-0 d-flex align-items-center gap-2 py-2 px-3 mb-3 rounded-2" role="alert">
      <i class="pi pi-info-circle flex-shrink-0"></i>
      <span class="small">{{ 'AgentManagement::AssignQueue:InfoMessage' | abpLocalization }}</span>
    </div>

    <div class="d-flex w-100">
      <div class="flex-grow-1 min-width-0">
        <cx-multi-select
          [options]="allQueues"
          optionLabel="name"
          optionValue="id"
          [appendTo]="null"
          class="w-100 d-block"
          styleClass="w-100"
          [placeholder]="'AgentManagement::AssignQueue:SelectPlaceholder' | abpLocalization"
          [selectedItemsLabel]="queuesSelectedLabel"
          [showClear]="true"
          [showHeader]="true"
          [filter]="true"
          [(ngModel)]="selectedQueueIds" />
      </div>
    </div>
  </ng-container>

  <ng-template #footer>
    <cx-form-actions
      layout="dialog"
      cancelVariant="outline-secondary"
      [cancelLabel]="'AbpUi::Cancel' | abpLocalization"
      [saveLabel]="'AbpUi::Save' | abpLocalization"
      saveType="button"
      [isSubmitting]="saving"
      (cancel)="onCancel()"
      (save)="onSave()">
    </cx-form-actions>
  </ng-template>
</p-dialog>

